import { render } from "./TwLayoutTwoColumn.vue?vue&type=template&id=7a7450b9"
import script from "./TwLayoutTwoColumn.vue?vue&type=script&lang=js"
export * from "./TwLayoutTwoColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__